import { useQuery } from 'react-query';
import axios from '../../../utils/axios';
import { apiurl } from '../../../config/apiUrl';

const fetchAdhocItem = () => {
  return axios.get(`${apiurl?.getAllPpeComponent}?isAdhoc=false&isAll=true`);
};

const getAdhocItem = () => {
  return useQuery(['getAllPpeComponent'], () => fetchAdhocItem(), { refetchOnWindowFocus: false });
};

export default getAdhocItem;
